module.exports = __webpack_public_path__ + "img/crown.d5f82085.png";